import { createApp } from "vue";
import LoginApp from "./LoginApp.vue";

createApp(LoginApp).mount("#app");
